import React from 'react';
import './footer.css';
import Copytext from '../Copytext/Copytext';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer>
      <div className='footer-content-holder'>
      <div className="linkFooterHolder">
        <div id="ContactMe" className="clickEmail">
          <Copytext />
          <p className="emailHover">Copy to clipboard</p>
        </div>

        <div className="footerImages">
          <a
            href="https://github.com/AllisonGriff"
            className="iconLink"
          >
            <FaGithub className="gitHub" />
          </a>

          <a
            href="https://www.linkedin.com/in/griffinallie/"
            className="iconLink"
          >
            <FaLinkedin className="linkedIN" />
          </a>
        </div>
      </div>

      <div className="footer">
        <p className="MyNameFooter">
          Allison<br />
          <span>Griffin</span>
        </p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
